// extracted by mini-css-extract-plugin
export default {"singleUserContainer":"SingleUser_singleUserContainer__bLgZa","twoFormItemContainer":"SingleUser_twoFormItemContainer__mTAO0","topButtons":"SingleUser_topButtons__Gtljw"};